import { useEffect, useMemo, useState } from "react";
import MasterComponent from "../../components/Forms";
import { FormColumnConfig, MasterConfigs } from "../../interfaces/entity";
import { FormInstance } from "antd";

const Stages = () => {
    const [formValues, setForm] = useState<any>(null);

    const config: MasterConfigs = useMemo(() => ({
        api: () => '/stages',
        modalTitle: () => 'Stages',
        isActionTab: true,
        isSteps: false,
        onDataLoad: (data) => {
            setForm(data);
        },
        handleValuesChange: (changedValues, allValues) => {
            if (allValues) {
                setForm(allValues);
            }
        },
        getFormColumns: () => [
            {
                label: 'Order',
                name: 'order',
                type: 'text',
                rules: [{ required: true, message: 'Please enter order' }],
                span: 8
            },
            {
                span: 16
            },
            {
                label: 'Name',
                name: 'name',
                type: 'text',
                rules: [{ required: true, message: 'Please enter name' }],
                span: 8
            },
            {
                label: 'Category',
                name: 'category',
                type: 'select',
                rules: [{ required: true, message: 'Please select category' }],
                children: ['Quotes', 'Deals'].map(ele => ({ name: ele, value: ele })),
                span: 8
            },
            {
                span: 8
            },
            formValues && formValues.category === 'Deals' && {
                label: 'Probability',
                name: 'probability',
                type: 'text',
                rules: [{ required: true, message: 'Please enter probability' }],
                span: 8
            },
            formValues && formValues.category === 'Deals' && {
                label: 'Lead Type',
                name: 'leadType',
                type: 'select',
                isCombo: true,
                rules: [{ required: true, message: 'Please select lead type' }],
                span: 8
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                span: 16,
            }
        ].filter(Boolean) as FormColumnConfig[],
        getColumns: () => [
            {
                title: 'Order',
                dataIndex: 'order',
                key: 'order',
                width: 100,
                sorter: (a, b) => a.order - b.order,
            },
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Category',
                dataIndex: 'category',
                key: 'category',
            },
            {
                title: 'Probability',
                dataIndex: 'probability',
                key: 'probability',
                render: (text, record) => record?.category === 'Deals' ? `${text}%` : '-'
            },
            {
                title: 'Description',
                dataIndex: 'description',
                key: 'description',
                ellipsis: true
            }
        ],
        combo: [{
            name: 'leadType',
            api: '/leads-types',
            idKey: '_id',
            render: (text) => text.name,
        }],
        actions: [
            {
                name: 'Add Stage',
                actionType: 'Add'
            }
        ],
        onClose: () => {
            setForm(null);
        }
    }), [formValues]);

    return (
        <MasterComponent config={config} isModal={true} />
    )
}

export default Stages;